/* eslint-disable */
import { http, httpgst } from '../../main'
import { store } from '../../store'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get_expenses({ commit, dispatch }, payload) {
    let pagination = {
      "perPage": payload.event.options.perPage,
      "page": payload.event.options.page,
      "sortKey": payload.event.options.sortKey ? payload.event.options.sortKey  : 'id',
      "ord": payload.event.options.ord,
      "find": payload.event.options.find !== '' && payload.event.options.find !== null ? payload.event.options.find : ''
    }
    let user =
    payload.event.user != null ? payload.event.user : payload.event.substitute
    if (user != null) {
      let typeUser =
        payload.event.context.validatorSubtitute.typeUser !== ''
          ? payload.event.context.validatorSubtitute.typeUser
          : 'Validator'
      // let url = 'api/expenses-validator/' + user.user_id + '?type=' + typeUser + '&perPage=' + params.perPage + '&page=' + params.page
      let url = 'api/expenses-validator/' + user.user_id + '?type=' + typeUser + '&perPage=' + pagination.perPage + '&page=' + pagination.page + '&sortBy=' + pagination.sortKey + '&ord=' + pagination.ord + '&find=' + pagination.find
      let options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      httpgst.get(url, {}, options).then(
        response => {
          commit('expensesGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
    }
  },
  get_userlogged({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options).then(
      response => {
        commit('userLogged', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  get_validator_substitute({ commit, dispatch }, payload) {
    let user =
      payload.event.user != null ? payload.event.user : payload.event.substitute
    if (user != null) {
      let url = 'api/validator-substitute/' + user.user_id
      let options = {
        emulateJSON: false,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common['Authorization'] =
        'Bearer ' + store.state.userState.access_token
      httpgst.get(url, {}, options).then(
        response => {
          commit('validatorSubtitute', {
            event: payload.event,
            response: response
          })
          let event = payload.event
          payload.event.context.$store.dispatch(
            'expensesValidate/get_expenses',
            { event }
          )
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
    }
  },
  delete_items({ commit, dispatch }, payload) {
    let expensesItemsIds = []
    let ctx = payload.event.context
    if (ctx.multipleSelectedRejec && ctx.multipleSelectedRejec === true) {
      expensesItemsIds = ctx.rejectedSelectedId
    } else {
      expensesItemsIds.push(payload.event.items.id)
    }
    let url = 'api/expenses-items/destroyItems'
    let params = {
      expenses_items_ids: expensesItemsIds,
      validator_comment: payload.event.items.validator_comment
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('itemsDelete', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  change_validador({ commit, dispatch }, payload) {
    let params = {
      comment_validator: payload.event.context.validat.optionalComment
        ? payload.event.context.validat.optionalComment
        : undefined
    }
    let url = 'api/changeStatusWorkflow/' + payload.event.expenses.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}, options).then(
      response => {
        commit('expensesPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  get_approbed({ commit, dispatch }, payload) {
    let pagination = {
      "perPage": payload.event.options.perPage,
      "page": payload.event.options.page,
      "sortKey": payload.event.options.sortKey ? payload.event.options.sortKey  : 'id',
      "ord": payload.event.options.ord,
      "find": payload.event.options.find !== '' && payload.event.options.find !== null ? payload.event.options.find : ''
    }
    payload.event.context.expensesApprobed = []
    let url = 'api/approved-expenses/' + payload.event.approbeds.company[0].id + '?perPage=' + pagination.perPage + '&page=' + pagination.page + '&sortBy=' + pagination.sortKey + '&ord=' + pagination.ord + '&find=' + pagination.find
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    // Bandera isExpenseApprovalView
    const requestData = {
      isExpenseApprovalView: true,
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { data: requestData }, options).then(
      response => {
        commit('getApprobed', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  approbed_expenses({ commit, dispatch }, payload) {
    let url = 'api/expenses-change-to-pay/' + payload.event.itemsV.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, options).then(
      response => {
        commit('putApprobedExpenses', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  categoryPut({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/' + payload.event.item.id
    let params = {
      gst_categories_id: payload.event.item.gst_category_id
    }
    
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  readXmlToHtml({ commit, dispatch }, payload) {
    let url = 'api/read-xml/' + payload.event.id + '/convert-to/html'
    // let url = 'api/read-xml/60/convert-to/html'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options).then(
      response => {
        if (
          payload.event.type
            ? payload.event.type === 'viewItemsApprobedF'
            : false
        ) {
          commit('onReadXmlToHtmlFA', {
            event: payload.event,
            response: response
          })
        } else if (
          payload.event.type ? payload.event.type === 'viewItemsF' : false
        ) {
          commit('onReadXmlToHtmlFV', {
            event: payload.event,
            response: response
          })
        } else {
          commit('onReadXmlToHtml', {
            event: payload.event,
            response: response
          })
        }
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  categoriesGet({ commit, dispatch }, payload) {
    let url = 'api/categories'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, options, {}).then(
      response => {
        commit('onCategoriesGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadRequest({ commit, dispatch }, payload) {
    let url =
      `api/travel-expenses-request/to-pdf/` + payload.event.expensesRequest
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/pdf'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options).then(
      response => {
        commit('onDownloadRequest', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  backCheckoutPut({ commit, dispatch }, payload) {
    let url = 'api/update-status-expense/' + payload.event.item.id
    let params = {
      comment: payload.event.item.comment
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onBackCheckoutPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
}

// mutations
const mutations = {
  onBackCheckoutPut(state, payload) {
    payload.event.context.refresh();
    payload.event.context.close();
    payload.event.context.showNotification(payload.response, 'success');
  },
  expensesGet(state, payload) {
    /* payload.event.context.expenses = payload.response.data.data */
    let itemsValidate = payload.response.data.data.data
    payload.event.context.isDataLoaded = false
    itemsValidate.forEach(element => {
      element.suma_total_items = 0
      element.gst_expenses_items.forEach(elements => {
        elements.views = false
        elements.tipGet = 0
        element.suma_total_items =
          parseFloat(elements.total_mxn !== null ? elements.total_mxn : 0) +
          element.suma_total_items
      })
    })
    payload.event.context.validateBtn = false
    payload.event.context.overlay = false
    payload.event.context.expenses = itemsValidate
    payload.event.context.expensesTotal()
    payload.event.context.loadingItems = false
    payload.event.context.pagination.rowsPerPage = parseInt(payload.response.data.data.per_page)
    payload.event.context.pagination.page = payload.response.data.data.current_page
    payload.event.context.totalValidate = payload.response.data.data.total
    payload.event.context.pagination.totalItems = payload.response.data.data.total
    payload.event.context.pagination.lastPage = payload.response.data.data.last_page;
  },
  validatorSubtitute(state, payload) {
    payload.event.context.validatorSubtitute.typeUser =
      payload.response.data.data.typeUser
  },
  userLogged(state, payload) {
    payload.event.context.userloggeds = payload.response.data.data
  },
  itemsDelete(state, payload) {
    /* let viewApprobedExpenses = payload.event.context.itemsNrewApproved.items
    viewApprobedExpenses.splice(payload.event.index, 1) */
    payload.event.context.removeExpenseItemFromItemsNew(payload.event.items.id)
    payload.event.context.confirmRejected()
    payload.event.context.closeDelete()
    payload.event.context.closeDeleteValidateF()
    payload.event.context.closeDeleteApprobed()
    payload.event.context.isDataLoaded = false
    payload.event.context.isDataAppLoaded = false
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
    // let editedItem = payload.event.context.editedItem
    // editedItem.splice(payload.event.index, 1)
    // payload.event.context.editedItem = editedItem
  },
  expensesPut(state, payload) {
    payload.event.context.confirmA()
    payload.event.context.refreshValidateExpenses()
    payload.event.context.showNotification(payload.response, 'success')
  },
  getApprobed(state, payload) {
    /* payload.event.context.expensesApprobed = payload.response.data.data */
    payload.event.context.isDataAppLoaded = false
    let itemsApprobed = payload.response.data.data.data
    payload.event.context.overlay = false
    payload.event.context.loadingItems = false
    itemsApprobed.forEach(element => {
      element.items.forEach(elements => {
        elements.tipGet = 0
        elements.views = false
      })
    })
    payload.event.context.expensesApprobed = itemsApprobed
    payload.event.context.expensesApprobedTotal()
    payload.event.context.pagination.rowsPerPage = parseInt(payload.response.data.data.per_page)
    payload.event.context.pagination.page = payload.response.data.data.current_page
    payload.event.context.totalApprobed = payload.response.data.data.total
    payload.event.context.pagination.totalItems = payload.response.data.data.total
    payload.event.context.pagination.lastPage = payload.response.data.data.last_page;
  },
  putApprobedExpenses(state, payload) {
    payload.event.context.confirm()
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
  },
  onPut(state, payload) {
    payload.event.context.loading = false
    payload.event.context.saveConfirm()
    payload.event.context.isDataLoaded = false
    payload.event.context.isDataAppLoaded = false
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
  },
  onReadXmlToHtmlFV(state, payload) {
    payload.event.context.dialogF = true
    let cfdiHtmlOrigin = payload.response.data.data
    let cfdiHtmlDecoded = atob(cfdiHtmlOrigin)
    let cfdiHtmlUnescaped = decodeURIComponent(escape(cfdiHtmlDecoded))
    payload.event.context.cfdiHtml = cfdiHtmlUnescaped
  },
  onReadXmlToHtmlFA(state, payload) {
    payload.event.context.dialogApprobedF = true
    let cfdiHtmlOrigin = payload.response.data.data
    let cfdiHtmlDecoded = atob(cfdiHtmlOrigin)
    let cfdiHtmlUnescaped = decodeURIComponent(escape(cfdiHtmlDecoded))
    payload.event.context.cfdiHtml = cfdiHtmlUnescaped
  },
  onError(state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.overlay = false
    payload.event.context.loadingItems = false
  },
  onDownloadRequest(state, payload) {
    payload.event.context.forceFileDownload(
      payload.response.data,
      'Request-' + payload.event.folio + '.pdf'
    )
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expensesValidate.js